import { Button, Group, Modal, Text } from '@mantine/core';
import { ReactNode } from 'react';

type Props = {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
  description: ReactNode;
  confirmLabel: string;
};

export function CrossAdvisorConfirmModal({
  opened,
  onClose,
  onConfirm,
  isLoading,
  description,
  confirmLabel,
}: Props) {
  return (
    <Modal opened={opened} onClose={onClose} title="Add a client from another advisor" centered>
      <Text mb="md">{description}</Text>
      <Group justify="flex-end">
        <Button variant="default" onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button variant="primary" loading={isLoading} onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </Group>
    </Modal>
  );
}
